import React, { FC } from 'react'
import UploadDocumentContainer from 'containers/UploadDocs'

const UploadUserPageDocsPage: FC = () => <UploadDocumentContainer />

export default UploadUserPageDocsPage
